import { useEffect,useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { setGZ } from "../redux/chartoptions";
import IndividualComponentPopup from "./individualcomponentpopup";



function Gz(){
   
    const [showModal,setShowModal] = useState(false);

    const myData = useSelector(state => state.api);

    let current_Gz = myData.Gz[0];

        
        
        const dispatch = useDispatch();
        const checked = useSelector(state => state.chartOption.Gz)

        const showPopup = () =>{
            setShowModal(true);
        }
    
        const hidePopup = () =>{
            setShowModal(false);
        }
        

    return(
        <>
            <div className="parameter" id="gz" onClick={showPopup}>                    
                <div className="label2">
                    <input type="checkbox" id="gz" checked={checked} onChange={(e) => {dispatch(setGZ(e.target.checked))}} />
                    <label htmlFor="gz" >Gz</label>
                </div>
                    
                <div className="parameter_ul">
                    <ul>
                        <li type="none">Current Gz : {parseFloat(current_Gz).toFixed(2)} <br/> </li>
                    </ul>
                </div>
            </div>
            {showModal && <IndividualComponentPopup hider={hidePopup} bgcolor={"#ef6262"} />}
        </>
    );
}

export default Gz;